<template>
  <div id="app">
    <router-view />
    <img
      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEyOCAxMjg7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48Zz48cGF0aCBkPSJNOTYuMSwxMDMuNmMtMTAuNCw4LjQtMjMuNSwxMi40LTM2LjgsMTEuMWMtMTAuNS0xLTIwLjMtNS4xLTI4LjItMTEuOEg0NHYtOEgxOHYyNmg4di0xMS45YzkuMSw3LjcsMjAuNCwxMi41LDMyLjYsMTMuNiAgIGMxLjksMC4yLDMuNywwLjMsNS41LDAuM2MxMy41LDAsMjYuNS00LjYsMzctMTMuMmMxOS4xLTE1LjQsMjYuNi00MC41LDE5LjEtNjMuOWwtNy42LDIuNEMxMTksNjguNiwxMTIuNiw5MC4zLDk2LjEsMTAzLjZ6Ii8+PHBhdGggZD0iTTEwMywxOS43Yy0yMS4yLTE4LjctNTMuNS0yMC03Ni4xLTEuNkM3LjksMzMuNSwwLjQsNTguNCw3LjcsODEuN2w3LjYtMi40QzksNTkuMiwxNS41LDM3LjYsMzEuOSwyNC40ICAgQzUxLjYsOC40LDc5LjcsOS42LDk4LDI2SDg1djhoMjZWOGgtOFYxOS43eiIvPjwvZz48L3N2Zz4="
    />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html {
  font-size: 1.5rem;
}
body {
  background: #030816;
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 1.2rem;
}
#app * {
  font-family: "Lobster", cursive;
  box-sizing: border-box;
  letter-spacing: 1px;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
  color: inherit;
}
a:hover {
  color: #42b983;
}

button {
  background: none;
  border: 1px solid #296047;
  border-radius: 4px;
  color: #35495e;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 1.5px;
  padding: 5px 10px;
  font-size: 0.8rem;
  outline: none;
}
button:hover {
  background: #42b983;
  border-radius: 4px;
  color: #ffffff;
}

#app.loadding:before {
  content: "";
  background: #0000008a;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
#app > img {
  width: 60px;
  display: none;
}
#app.loadding > img {
  filter: invert(0.65);
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -100%);
  animation: load 1s infinite linear;
  display: unset;
}
@keyframes load {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 500px) {
  html {
    font-size: 1rem;
  }
  #app {
    width: 94vw;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue